<template>
  <section class="innerpage-wrap p-0">
    <div class="container p-0" ref="saveContactInfo">
      <div class="split-title" v-if="!isRedirectionFromReview">
        <h1 class="brand-color">Contact Information</h1>
      </div>
      <div class="enrollmentForm" :class="[isRedirectionFromReview ? 'review-card-block' : 'card-block']">
        <form action="index.html" method="post">
          <div class="form-group row">
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4"
              v-if="formFields.email_address.required == true">
              <label> Email (Must be Client email)
                <span class="required" v-if="!(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">*</span>
              </label>
              <div class="d-flex align-items-center">
                <div class="w-100  custom-input p-0 info-input" style="margin-top: 4px; display: flex;"
                  :class="{ 'form-control is-invalid': $v.formFields.email_address.value.$error || formErrors['email_address_message'] || emailPhoneError.email_error_msg }">
                  <input type="text" id="email" value="" ref="email"
                    @input="$v.formFields.email_address.value.$touch(); removeError();"
                    v-model="formFields.email_address.value" class="inner-input"
                    placeholder="Enter Client Email Address" />
                  <span v-if="isEmailInvalid">
                    <span @click="showEmailInvalidMsg = true"><i
                        class="fa fa-exclamation-circle exclaim-icon"></i></span>
                    <div class="info-box" v-if="showEmailInvalidMsg">
                      {{ formErrors['email_address_message'] }}
                      {{ emailPhoneError.email_error_msg }}
                      <span @click="showEmailInvalidMsg = false" class="cursor-pointer"><i
                          class="fas fa-times"></i></span>
                    </div>
                  </span>
                  <div class="custom-check-wrap" v-if="isEmailVerificationSuccess" style="margin-top: 8px;">
                    <i class="fa fa-check custom-check"></i>
                  </div>
                </div>

              </div>

              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.email_address.value.email && formFields.email_address.value && $v.formFields.email_address.value.$error">
                Invalid email format. Please enter a valid email
              </div>
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.email_address.value.required && $v.formFields.email_address.value.$error && !(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">
                Field is required
              </div>
              <div v-if="(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">
                <div class="form-group__message text-left ml-3 mt-2 text-danger" v-if="atLeastOneContactError">
                  Please provide at least one contact method (email or phone number)
                </div>
              </div>

              <div class="error_message" v-if="formErrorFlag == true">
                <span v-if="!isEmailInvalid">{{ formErrors['email_address_message'] }}</span>
                <span @click="renderVerificationModal('email')" v-if="isEmailInvalid">
                  <span @click="renderVerificationModal('email')" class="verification-error-text click-link"> Click Here
                  </span><span class="bl-color">to validate via OTP.</span>
                </span>
                <div class="skip-msg mt-1" v-if="isEmailInvalid">
                  <input class="form-check-input me-2 mt-0" type="checkbox" name="" id="inlinecheckbox2" :true-value="1"
                    :false-value="0" v-model="skipValidateEmail">
                  <label class="form-check-label skip-label skip-link" for="inlinecheckbox2">Skip Email
                    Validation</label>
                </div>
              </div>
            </div>
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4"
              v-if="formFields.phone_number.required == true">
              <label>Contact Number <span class="required"
                  v-if="!(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">*</span></label>
              <div class="d-flex align-items-center">
                <div class="w-100 custom-input p-0 info-input" style="margin-top: 4px; display: flex;"
                  :class="{ 'form-control is-invalid': $v.formFields.phone_number.value.$error || formErrors['phone_number_message'] || emailPhoneError.phone_error_msg }">
                  <input type="text" id="phone" v-model="formFields.phone_number.value" class="inner-input"
                    @input="$v.formFields.phone_number.value.$touch(); removeError();" maxlength="10" ref="phone"
                    placeholder="Enter Contact Number" />
                  <span v-if="isPhoneInvalid">
                    <span @click="showPhoneInvalidMsg = true"><i
                        class="fa fa-exclamation-circle exclaim-icon"></i></span>
                    <div class="info-box contact-num" v-if="showPhoneInvalidMsg">
                      {{ formErrors['phone_number_message'] }}
                      {{ emailPhoneError.phone_error_msg }}
                      <span @click="showPhoneInvalidMsg = false" class="cursor-pointer"><i
                          class="fas fa-times"></i></span>
                    </div>
                  </span>
                  <div class="custom-check-wrap" v-if="isPhoneVerificationSuccess" style="margin-top: 8px;">
                    <i class="fa fa-check custom-check"></i>
                  </div>
                </div>
              </div>
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.phone_number.value.required && $v.formFields.phone_number.value.$error && !(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">
                Field is required
              </div>
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="$v.formFields.phone_number.value.required && $v.formFields.phone_number.value.$invalid">
                Invalid phone number. Please enter a 10-digit numeric phone number
              </div>
              <div class="error_message" v-if="formErrorFlag == true">
                <span v-if="!isPhoneInvalid">{{ formErrors['phone_number_message'] }} </span>
                <span v-if="isPhoneInvalid">
                  <span @click="renderVerificationModal('phoneNumber')" class="verification-error-text click-link">
                    Click Here </span><span class="bl-color"> to validate via OTP.</span>
                </span>
                <div class="skip-msg mt-1" v-if="isPhoneInvalid">
                  <input class="form-check-input me-2 mt-0" type="checkbox" name="" id="inlinecheckbox2" :true-value="1"
                    :false-value="0" v-model="skipValidatePhone">
                  <label class="form-check-label skip-label skip-link" for="inlinecheckbox2">Skip Phone
                    Validation</label>
                </div>
              </div>
            </div>




            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.address1.required == true">
              <label>Street Address 1 <span class="required">*</span></label>
              <input type="text" class="custom-input" @input="$v.formFields.address1.value.$touch(); removeError();"
                :class="{ 'form-control is-invalid': $v.formFields.address1.value.$error || formErrors['address1_message'] }"
                placeholder="Enter Street Address" v-model="formFields.address1.value" value="">
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.address1.value.required && $v.formFields.address1.value.$error">
                Field is required
              </div>
              <div class="error_message ml-3 mt-2" v-if="formErrorFlag == true">
                {{ formErrors['address1_message'] }}
              </div>
            </div>
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.address2.required == true">
              <label>Street Address 2 <span class="required">*</span></label>
              <input type="text" class="custom-input" @input="$v.formFields.address2.value.$touch(); removeError();"
                :class="{ 'form-control is-invalid': $v.formFields.address2.value.$error || formErrors['address2_message'] }"
                placeholder="Enter
                                   Street Address" v-model="formFields.address2.value" value="">
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.address2.value.required && $v.formFields.address2.value.$error">
                Field is required
              </div>
              <div class="error_message" v-if="formErrorFlag == true">
                {{ formErrors['address2_message'] }}
              </div>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.city.required == true">
              <label>City <span class="required">*</span></label>
              <input type="text" class="custom-input" @input="$v.formFields.city.value.$touch(); removeError();"
                :class="{ 'form-control is-invalid': $v.formFields.city.value.$error || formErrors['city_message'] }"
                placeholder="Enter City" v-model="formFields.city.value" value="">
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.city.value.required && $v.formFields.city.value.$error">
                Field is required
              </div>
              <div class="error_message" v-if="formErrorFlag == true">{{ formErrors['city_message'] }}</div>
            </div>

            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.zip.required == true">
              <label>Zip <span class="required">*</span></label>
              <input type="text" class="custom-input"
                style="background-color: -internal-light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));"
                @input="$v.formFields.zip.value.$touch(); checkZipError();" placeholder="Enter Zip Code"
                :class="{ 'form-control is-invalid': $v.formFields.zip.value.$error || formErrors['zip_message'] }"
                v-model="formFields.zip.value" value=""
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                maxlength="5">
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.zip.value.required && $v.formFields.zip.value.$error">
                Field is required
              </div>
              <div class="form-group__message  ml-3 mt-2"
                v-if="$v.formFields.zip.value.required && $v.formFields.zip.value.$error">
                Enter 5 digit zip code
              </div>
              <div class="error_message mt-2" v-if="formErrorFlag == true">{{ formErrors['zip_message'] }}</div>
            </div>
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.state.required == true">
              <label>State <span class="required">*</span></label>
              <input type="text" class="custom-input" placeholder="Enter state" :disabled="disableState"
                @input="$v.formFields.state.value.$touch();"
                :class="{ 'form-control is-invalid': $v.formFields.state.value.$error }"
                v-model="formFields.state.value" maxlength="2" @keypress="onlyAlpha($event)" v-on:keyup="stateCase()"
                value="">
              <div class="form-group__message text-left ml-3 mt-2"
                v-if="!$v.formFields.state.value.required && $v.formFields.state.value.$error">
                Field is required
              </div>
              <div class="error_message mt-2" v-if="formErrorFlag == true">{{ formErrors['state_message'] }}</div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.birth_state.required">
              <label>Birth State <span class="required">*</span></label>
              <b-form-select name="" class="custom-input"
                @input="$v.formFields.birth_state.value.$touch(); removeError();"
                :class="{ 'form-control is-invalid': $v.formFields.birth_state.value.$error || formErrors['birth_state_message'] }"
                v-model="formFields.birth_state.value" id="">
                <option value="null" disabled>Select birth State</option>
                <option v-for="state in states" :value="state.abbrev" :key="state.abbrev">{{ state.name }}
                  ({{ state.abbrev }})</option>
              </b-form-select>
              <div class="error_message" v-if="formErrorFlag == true">{{ formErrors['birth_state_message'] }}</div>
            </div>
            <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12  mb-4" v-if="formFields.birth_city.required">
              <label>Birth City <span class="required">*</span></label>
              <input type="text" @input="$v.formFields.birth_city.value.$touch(); removeError();"
                :class="{ 'form-control is-invalid': $v.formFields.birth_city.value.$error || formErrors['birth_city_message'] }"
                class="custom-input" placeholder="Enter birth city" v-model="formFields.birth_city.value">
              <div class="error_message" v-if="formErrorFlag == true">{{ formErrors['birth_city_message'] }}</div>
            </div>
          </div>

          <div class="form-group" v-if="!(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">
            <div class="form-check form-check-inline" v-if="formFields.with_validation.required == true">
              <input class="form-check-input" type="checkbox" name="" id="inlinecheckbox1"
                v-model="formFields.with_validation.value">
              <label class="form-check-label" for="inlinecheckbox1">USPS Address Validation</label>
              <div class="error_message" v-if="formErrorFlag == true">{{ formErrors['UspsAddress_message'] }}</div>
            </div>
          </div>
        </form>
        <p class="short-msg" v-if="!(checkExtraHealthRedirection() || checkAetnaDentalRedirection())">
          <strong>Important:</strong> Applicant will get an electronic copy of the enrollment, and will receive an email
          within 10 minutes upon completion of enrollment
        </p>
      </div>
      <div class="action-btn split-title mt-5" v-if="!isRedirectionFromReview">
        <router-link to="" @click.native="navigatePrevious" class="dark-btn">Back</router-link>
        <div class="action-next">
          <CancelEnrollmentButton />
          <router-link to="" @click.native="saveEnrollment" class="button-green"
            v-if="!(checkExtraHealthRedirection()) && !(checkAetnaDentalRedirection())">Save & Continue
            Later</router-link>
          <router-link to="" class="button-brand" @click.native="checkEmailPhone"
            v-if="enrollment_type == 'existing-user'">Next</router-link>
          <router-link to="" class="button-brand" @click.native="saveData" v-else>Next</router-link>
        </div>
      </div>

      <b-modal v-bind:hide-footer="true" id="code-send" centered size="md">
        <template #modal-header>
          <div class="popUp-header" style="border-bottom: 0px !important">
            <div v-if="saveSuccess">
              <h4 style="color: green"><b>Information Saved!!!</b> Check your email to continue</h4>
            </div>
            <div v-else>
              <h4>Please enter the alternate email you want to send Enrollment code to?</h4>
            </div>
            <b-button variant="close-btn" @click="$bvModal.hide('code-send')">
              <i class="fas fa-times"></i>
            </b-button>
          </div>
        </template>
        <b-container fluid>

          <div v-if="saveSuccess == false" class="input_box client_email">
            <input type="text" class="custom-input"
              :class="{ 'form-control is-invalid': email && !isEmailValid || isEmailNull }"
              @input="emailValid(); removeError();" v-model="email" value="" />
            <div class="form-group__message  ml-3 mt-2" v-if="email && !isEmailValid || isEmailNull">
              Enter valid email address
            </div>
            <div class="error_message" v-if="formErrorFlag == true">{{ formErrors['email_message'] }}</div>
          </div>
          <div class="popUp-details text-center">
            <div v-if="saveSuccess" class="action-btn text-center mt-4">
              <b-button style="width:100%;" class="button-brand mx-1" @click="$bvModal.hide('code-send')"
                data-dismiss="modal">Done</b-button>
            </div>
            <div v-else class="action-btn text-center mt-4">
              <b-button style="width:40%;" class="dark-btn mx-1" @click="$bvModal.hide('code-send')">Back</b-button>
              <b-button style="width:40%;" class="button-brand mx-1" @click="saveAndContinueEnrollment"
                data-dismiss="modal">Send Code</b-button>
            </div>
          </div>
        </b-container>

      </b-modal>

    </div>
    <div v-if="isRedirectionFromReview">
      <cancel-continue-button @submitEditInfo="saveData" @cancelEditInfo="cancelEditInfo" />
    </div>
    <div>
      <email-phone-verification :verificationType="verificationType" :verificationObj="verificationObj"
        @verificationStatus="renderVerificationStatus" />
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import html2canvas from 'html2canvas';
import { required, email, requiredIf } from "vuelidate/lib/validators";
import { checkValidPhoneNumber, checkEmail, checkValidZip } from "../../utils/validators";
import { checkExtraHealthGroup, checkAetnaDentalAccess } from "../../utils/checkPlatform";
import CancelEnrollmentButton from "../CancelEnrollmentButton";
import EmailPhoneVerification from "../../views/EmailPhoneVerification";
import { zipValidation } from "../../utils/commonApi";
import CancelContinueButton from "./ReviewEdit/CancelContinueButton";
import { efTrack } from "../../utils/EfTrack";

export default {
  name: "ContactInformation",
  data() {
    return {
      tempId: '',
      // formFields: [],
      formFields: {
        address1: {
          value: '',
          required: false,
          read_only: false,
        },
        address2: {
          value: '',
          required: false,
          read_only: false,
        },
        city: {
          value: '',
          required: false,
          read_only: false,
        },
        zip: {
          value: 0,
          required: false,
          read_only: false,
        },
        phone_number: {
          value: 0,
          required: false,
          read_only: false,
        },
        email_address: {
          value: '',
          required: false,
          read_only: false,
        },
        birth_state: {
          value: '',
          required: false,
          read_only: false,
        },
        birth_city: {
          value: '',
          required: false,
          read_only: false,
        },
        with_validation: {
          value: true,
          required: false,
          read_only: false,
        },
        state: {
          value: '',
          required: false,
          read_only: false,
        }
      },
      state: [],
      formErrors: [],
      formErrorFlag: false,
      savePopup: false,
      email: '',
      saveSuccess: false,
      invalidPopup: true,
      email_valid: true,
      phone_valid: true,
      invalid_message: '',
      enrollment_type: '',
      phone_msg: '',
      isEmailNull: false,
      isEmailValid: false,
      checkPrudential: false,
      isPhoneInvalid: false,
      isEmailInvalid: false,
      isPhoneVerificationSuccess: false,
      isEmailVerificationSuccess: false,
      verificationType: '',
      verificationObj: {},
      verificationEmailPng: 'https://enrollmentlogo.s3.us-east-2.amazonaws.com/not-sent.png',
      verificationPhonePng: 'https://enrollmentlogo.s3.us-east-2.amazonaws.com/warning-sign.png',
      skipValidateEmail: 0,
      skipValidatePhone: 0,
      enrollBy: '',
      showEmailInvalidMsg: false,
      showPhoneInvalidMsg: false,
      emailPhoneError: {
        email_error_msg: '',
        phone_error_msg: ''
      },
      disableState: false
    }
  },
  computed: {
    atLeastOneContactError() {
      if (this.checkExtraHealthRedirection() || this.checkAetnaDentalRedirection()) {
        return !this.formFields.email_address.value && !this.formFields.phone_number.value &&
          (this.$v.formFields.email_address.value.$error || this.$v.formFields.phone_number.value.$error);
      }
      return false;
    },
    landingInfo() {
      return this.$store.getters.getLandingInfo
    },
  },
  components: {
    CancelEnrollmentButton,
    EmailPhoneVerification,
    CancelContinueButton
  },
  props: {
    isRedirectionFromReview: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    if (this.checkExtraHealthRedirection() || this.checkAetnaDentalRedirection()) {
      if (this.formFields.address2.required) {
        if (this.formFields.birth_state.required == true && this.formFields.birth_city.required) {
          return {
            formFields: {
              email_address: {
                value: {
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              address2: {
                value: {
                  required
                }
              },
              birth_state: {
                value: {
                  required
                }
              },
              birth_city: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        } else {
          return {
            formFields: {
              email_address: {
                value: {
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              address2: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        }

      } else {
        if (this.formFields.birth_state.required == true && this.formFields.birth_city.required) {
          return {
            formFields: {
              email_address: {
                value: {
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              birth_state: {
                value: {
                  required
                }
              },
              birth_city: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        } else {
          return {
            formFields: {
              email_address: {
                value: {
                  email,
                  required: requiredIf(function () {
                    return !this.formFields.phone_number.value;
                  })
                }
              },
              phone_number: {
                value: {
                  required: requiredIf(function () {
                    return !this.formFields.email_address.value;
                  }),
                  checkValidPhoneNumber: function (value) {
                    if (value) {
                      return checkValidPhoneNumber(value);
                    }
                    return true;
                  }
                }
              }
              ,
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        }
      }
    } else {
      if (this.formFields.address2.required) {
        if (this.formFields.birth_state.required == true && this.formFields.birth_city.required) {
          return {
            formFields: {
              email_address: {
                value: {
                  required,
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              address2: {
                value: {
                  required
                }
              },
              birth_state: {
                value: {
                  required
                }
              },
              birth_city: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        } else {
          return {
            formFields: {
              email_address: {
                value: {
                  required,
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              address2: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        }

      } else {
        if (this.formFields.birth_state.required == true && this.formFields.birth_city.required) {
          return {
            formFields: {
              email_address: {
                value: {
                  required,
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              birth_state: {
                value: {
                  required
                }
              },
              birth_city: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        } else {
          return {
            formFields: {
              email_address: {
                value: {
                  required,
                  email
                }
              },
              phone_number: {
                value: {
                  required,
                  checkValidPhoneNumber
                }
              },
              city: {
                value: {
                  required
                }
              },
              address1: {
                value: {
                  required
                }
              },
              zip: {
                value: {
                  required,
                  checkValidZip
                }
              },
              state: {
                value: {
                  required
                }
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    let app = this;
    app.tempId = window.localStorage.getItem('tempId');
    app.enrollBy = window.localStorage.getItem('enrollBy');
    app.getStates();
    app.scrollTop();
    app.checkPrudentialCart();
    app.getFields();
    app.getEnrollmentType();
  },
  methods: {
    validateEmail: function () {
      let app = this;
      let params = {
        email: app.formFields.email_address.value,
      };
      axios.post(process.env.VUE_APP_API_BASE + '/validate-member-email', params)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.status == 'success') {
            app.formErrorFlag = false;
            app.formErrors['email_address_message'] = '';
          }
        })
        .catch(function (error) {
          console.log(error.response.data.data);
          if (error.response.data.status == 'error') {
            error.response.data.data.forEach(function (item) {
              app.formErrorFlag = true;
              app.formErrors[item.target_element + '_message'] = item.error_message;
            });
          }
        });
    },
    getStates: function () {
      let app = this;
      axios.get(process.env.VUE_APP_API_BASE + '/get-states')
        .then(function (response) {
          if (response.data.status == 'success') {
            app.states = response.data.data.result;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getFields: function () {
      let app = this;
      axios.get(process.env.VUE_APP_API_BASE + '/get-form-fields-contact-info', {
        params: {
          enrollment_id: app.tempId,
        }
      })
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.status == 'success') {
            response.data.data.result.forEach(function (item) {
              app.formFields[item.field_name] = item;
            });
          }
          app.fetchInfo();
          console.log(app.formFields);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    fetchInfo: function () {
      let app = this;
      axios.get(process.env.VUE_APP_API_BASE + '/get-enrollment-temp-info', {
        params: {
          enrollment_id: app.tempId,
          column: 'contact_info',
        }
      })
        .then(function (response) {
          if (response.data.status == 'success') {
            console.log('This is the fetched data' + JSON.stringify(response.data.data.result));
            app.formFields.address1.value = response.data.data.result.address1;
            app.formFields.city.value = response.data.data.result.city;
            app.formFields.phone_number.value = response.data.data.result.phone_number;
            app.formFields.email_address.value = response.data.data.result.email_address;
            app.formFields.birth_state.value = response.data.data.result.birth_state;
            app.formFields.birth_city.value = response.data.data.result.birth_city;
            app.formFields.with_validation.value = response.data.data.result.with_validation;
            app.formFields.zip.value = response.data.data.result.zip;
            // for(var i in response.data.data.result) {
            //     fetchedData.push([i, response.data.data.result [i]]);
            // }
            // fetchedData.forEach(function(item) {
            //     let key = item[0];
            //     let val = item[1];
            //     app.formFields[key]['value'] = val;
            // });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveData: function () {
      this.$v.$touch();
      this.restVerificationErrorFlag();
      if (this.checkExtraHealthRedirection() || this.checkAetnaDentalRedirection()) {
        if ((!this.formFields.email_address.value && !this.formFields.phone_number.value) ||
          (this.formFields.email_address.value && this.$v.formFields.email_address.value.$invalid) ||
          (this.formFields.phone_number.value && this.$v.formFields.phone_number.value.$invalid)) {
          console.log('***** Inside Save Data Invalid*****')
          return false;
        }
      } else {
        if (this.$v.$invalid) {
          console.log('***** Inside Save Data Invalid*****')
          return false;
        }
      }
      if (this.$v.$invalid) {
        console.log('***** Inside Save Data Invalid*****')
        return false
      } else {
        const el = this.$refs.saveContactInfo;
        const checkBoxes = el.querySelectorAll('.form-check-input');
        checkBoxes.forEach(cb => {
          cb.style.setProperty('--bs-form-check-bg-image', 'none');
        });
        (async () => {
          this.saveScreenShot((await html2canvas(el)).toDataURL('image/png'), 'contact_info');
          this.screenShotData = (await html2canvas(el)).toDataURL();
          checkBoxes.forEach(cb => {
            cb.style.removeProperty('--bs-form-check-bg-image');
          });
        })();
        // Submit API
        let app = this;
        var with_validation = 0;
        if (app.formFields.with_validation.value == true) {
          with_validation = 1;
        } else {
          with_validation = 0;
        }
        app.formErrorFlag = false;
        app.formErrors = [];
        let params = {
          enrollment_id: app.tempId,
          address1: app.formFields.address1.value,
          address2: app.formFields.address2.value,
          city: app.formFields.city.value,
          state: app.formFields.state.value,
          zip: app.formFields.zip.value,
          phone_number: app.formFields.phone_number.value,
          email_address: app.formFields.email_address.value ? app.formFields.email_address.value : '',
          birth_state: app.formFields.birth_state.value,
          birth_city: app.formFields.birth_city.value,
          with_validation: with_validation,
          skip_validation_email: app.skipValidateEmail,
          skip_validation_phone: app.skipValidatePhone
        };
        //discard null values
        for (const key of Object.keys(params)) {
          if (params[key] === null) {
            delete params[key];
          }
        }
        console.log(params);
        axios.post(process.env.VUE_APP_API_BASE + '/save-contact-info', params)
          .then(function (response) {
            if (response.data.status == 'success') {
              console.log("success");
              app.saveAndContinue();
              (app.isRedirectionFromReview) && (app.renderUpdatedEditInfo());
              (app.checkAetnaDentalRedirection() && app.loadEverflowScript(22, 25));
            }
          })
          .catch(function (error) {
            app.renderContactError(error);
          });
      }
    },
    renderContactError(error) {
      // Error handing function to handle contact error
      let app = this
      app.emailPhoneError = {}
      if (error?.response?.data?.errors?.email || error?.response?.data?.errors?.phone) {
        if (error?.response?.data?.errors?.email) {
          error.response.data.errors.email.data.forEach(function (item) {
            app.formErrorFlag = true;
            if (item.error_message === 'Email Already Exists.') {
              app.isEmailInvalid = false
              app.formErrors[item.target_element + '_message'] = item.error_message;
            } else {
              (item.target_element === 'email_address') && ((app.isEmailInvalid = !item.is_valid) && (app.showEmailInvalidMsg = !item.is_valid) && (app.emailPhoneError['email_error_msg'] = item.error_message));
            }
          })
        }
        if (error?.response?.data?.errors?.phone) {
          error.response.data.errors.phone.data.forEach(function (item) {
            app.formErrorFlag = true;
            if (item.error_message === 'Phone already exists') {
              app.isPhoneInvalid = false
              app.formErrors[item.target_element + '_message'] = item.error_message;
            } else {
              (item.target_element === 'phone_number') && ((app.isPhoneInvalid = !item.is_valid) && (app.showPhoneInvalidMsg = !item.is_valid) && (app.emailPhoneError['phone_error_msg'] = item.error_message));
            }
          })
        }
      } else {
        if (error.response.data.status == 'error') {
          error.response.data.data.forEach(function (item) {
            app.formErrorFlag = true;
            app.formErrors[item.target_element + '_message'] = item.error_message;
          });
        }
      }
    },
    checkEmailPhone() {
      let app = this;
      app.$v.$touch();
      if (app.$v.$invalid) {
        console.log('***** Inside Save Data Invalid*****')
        return false
      } else {
        axios.get(process.env.VUE_APP_API_BASE + '/validate-phone-numverify', {
          params: {
            phone: app.formFields.phone_number.value,
          }
        })
          .then(function (response) {
            if (response.data.status == 'success') {
              console.log("success");
              app.phone_valid = true;
            }
          })
          .catch(function (error) {
            if (error.response.data.status == 'error') {
              error.response.data.data.forEach(function (item) {
                app.formErrorFlag = true;
                app.formErrors[item.target_element + '_number_message'] = item.error_message;
              });
              app.phone_valid = false;
            }
          });
        let params = {
          email: app.formFields.email_address.value
        }
        axios.post(process.env.VUE_APP_API_BASE + '/validate-email-neverbounce', params)
          .then(function (response) {
            if (response.data.status == 'success') {
              console.log("success");
              app.email_valid = true;
              if (app.phone_valid == true) {
                app.saveData();
              }
            }
          })
          .catch(function (error) {
            if (error.response.data.status == 'error') {
              error.response.data.data.forEach(function (item) {
                app.formErrorFlag = true;
                app.formErrors[item.target_element + '_address_message'] = item.error_message;
              });
              app.email_valid = false;
            }
          });
      }
    },
    focusCursor() {
      let app = this;
      if (!app.email_valid) {
        app.$refs.email.focus();
      } else if (!app.phone_valid) {
        app.$refs.phone.focus();
      }
      app.closePopupInvalid();
    },
    getEnrollmentType() {
      let app = this;
      axios.get(process.env.VUE_APP_API_BASE + '/get-enrollment-temp-info', {
        params: {
          enrollment_id: app.tempId,
          column: 'type',
        }
      })
        .then(function (response) {
          if (response.data.status == 'success') {
            app.enrollment_type = response.data.data.result;
          }
        })
        .catch(function (error) {
          if (error.response.data.status == 'error') {
            console.log('error');
            app.enrollment_type = '';
          }
        });
    },
    saveAndContinue() {
      //Update APIs
      //Navigate to next page
      if (localStorage.getItem("navto") === null || localStorage.getItem("navto") === undefined || localStorage.getItem("navto") === '') {
        this.$emit('comEnvNavigation', this.$route.name);
      } else {
        window.localStorage.removeItem('navto');
        this.$router.push('review-confirm');
      }
    },
    saveEnrollment: function () {
      let app = this;
      app.$bvModal.show('code-send');
    },
    saveAndContinueEnrollment: function () {
      if (!this.isEmailValid) {
        this.isEmailNull = true;
      } else {
        this.isEmailNull = false;
        let app = this;
        let params = {
          address1: app.formFields.address1.value,
          address2: app.formFields.address2.value,
          city: app.formFields.city.value,
          state: app.formFields.state.value,
          zip: app.formFields.zip.value,
          phone_number: app.formFields.phone_number.value,
          email_address: app.formFields.email_address.value,
        };
        for (const key of Object.keys(params)) {
          if (params[key] === null) {
            delete params[key];
          }
        }
        let data = {
          enrollment_id: app.tempId,
          email: app.email,
          tab: 'contact_info',
          data: params
        }
        console.log('called');
        console.log(this.saveEmail);
        console.log(params);
        app.formErrorFlag = false;
        app.formErrors = [];
        axios.post(process.env.VUE_APP_API_BASE + '/save-enrollment', data)
          .then(function (response) {
            if (response.data.status == 'success') {
              app.saveSuccess = true;
              console.log("success");
              // app.saveAndContinue();
            }
          })
          .catch(function (error) {
            if (error.response.data.status == 'error') {
              console.log('error');
              error.response.data.data.forEach(function (item) {
                app.formErrorFlag = true;
                app.formErrors[item.target_element + '_message'] = item.error_message;
              });
              console.log(app.formErrors);
            }
          });
      }
    },
    closePopup: function () {
      let app = this;
      app.savePopup = false;
    },
    closePopupInvalid: function () {
      let app = this;
      app.email_valid = true;
      app.phone_valid = true;
    },
    navigatePrevious() {
      //Update APIs
      //Navigate to next page
      this.$emit('comEnvNavigationBack', this.$route.name);
    },
    checkPrudentialCart() {
      let app = this;
      axios.get(process.env.VUE_APP_API_BASE + '/check-prudential-cart', {
        params: {
          enrollment_id: app.tempId,
        }
      })
        .then(function (response) {
          if (response.data.status == 'success') {
            app.checkPrudential = response.data.data.status;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveScreenShot(image, name) {
      let app = this;
      let data = {
        "enrollment_id": app.tempId,
        "name": name,
        "image": image
      };
      let config = {
        method: 'post',
        url: process.env.VUE_APP_API_BASE + '/save-screenshot',
        headers: {},
        data: data
      };
      axios(config)
        .then(function (response) {
          if (response.data.status == 'success') {
            console.log('screenshot saved');
          }
        })
        .catch(function (error) {
          console.log('screenshot not saved');
          console.log(error);
        });
    },

    scrollTop() {
      window.scrollTo(0, 0);
    },
    checkPhone() {
      let app = this;
      if (app.formFields.phone_number.value.length > 9) {
        axios.get(process.env.VUE_APP_API_BASE + '/validate-phone-numverify', {
          params: {
            phone: app.formFields.phone_number.value,
          }
        })
          .then(function (response) {
            if (response.data.status == 'success') {
              app.formErrorFlag = false;
              app.formErrors['phone_number_message'] = '';
            }
          })
          .catch(function (error) {
            if (error.response.data.status == 'error') {
              error.response.data.data.forEach(function (item) {
                if (item.target_element == 'phone') {
                  app.formErrorFlag = true;
                  app.formErrors['phone_number_message'] = item.error_message;
                }
              });
            }
          });
      }
    },

    removeError() {
      this.formErrors = [],
        this.isPhoneInvalid = false
      this.isEmailInvalid = false,
        this.emailPhoneError = {
          email_error_msg: '',
          phone_error_msg: ''
        }
    },
    removeSkipValidationError() {
      this.showEmailInvalidMsg = false
      this.showPhoneInvalidMsg = false
    },
    emailValid() {
      this.isEmailValid = checkEmail(this.email)
      this.isEmailNull = !checkEmail(this.email)
    },
    renderVerificationModal(type) {
      let app = this
      app.$bvModal.show('verifyModal')
      app.verificationType = type
      app.verificationObj['email'] = app.formFields.email_address.value
      app.verificationObj['phoneNumber'] = app.formFields.phone_number.value
    },
    renderVerificationStatus(params) {
      let app = this
      if (params.type === 'email') {
        app.isEmailVerificationSuccess = true
        app.isEmailInvalid = false
        app.formFields.email_address.value = params.contact
        app.emailPhoneError.email_error_msg = ''
      }
      if (params.type === 'phone') {
        app.isPhoneVerificationSuccess = true
        app.isPhoneInvalid = false
        app.formFields.phone_number.value = params.contact
        app.emailPhoneError.phone_error_msg = ''
      }
    },
    restVerificationErrorFlag() {
      let app = this
      app.isPhoneInvalid = false,
        app.isEmailInvalid = false,
        app.isPhoneVerificationSuccess = false,
        app.isEmailVerificationSuccess = false
    },
    cancelEditInfo() {
      let app = this
      app.$emit('cancelEditInfo')
    },
    renderUpdatedEditInfo() {
      let app = this
      app.$emit('updatedEditInfo')
    },
    checkExtraHealthRedirection() {
      let app = this
      return (checkExtraHealthGroup(app.landingInfo))
    },
    checkAetnaDentalRedirection() {
      let app = this
      return (checkAetnaDentalAccess(app.landingInfo))
    },
    stateCase() {
      let app = this;
      let state = app.formFields.state.value;
      state = state.toUpperCase();
      app.formFields.state.value = state;
    },
    checkZipError() {
      this.formErrors = []
      this.formErrorFlag = false
      this.formFields.state.value = ''
      this.disableState = false
      this.isPhoneInvalid = false
      this.isEmailInvalid = false
      this.emailPhoneError = {
        email_error_msg: '',
        phone_error_msg: ''
      }
    },
    onlyAlpha(e) {
      const char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      e.preventDefault();
      return false;
    },
    async fetchStateByZip(zip) {
      let app = this;
      try {
        const response = await zipValidation(zip)
        let state = response.data[0].state_abbreviation
        this.formFields.state.value = state
        app.disableState = true
      } catch (error) {
        app.formErrorFlag = true;
        app.formErrors['zip_message'] = error.error_message;
        app.formFields.state.value = ''
      }
    },
    loadEverflowScript (offerId, eventId) {
      efTrack (offerId, eventId)
    }
  },
  watch: {
    'formFields.zip.value': function (newZip) {
      if (newZip && newZip.length === 5) {
        this.fetchStateByZip(newZip);
      }
    }
  }
}
</script>

<style scoped>
.custom-check-wrap {
  background-color: #11809c;
  border-radius: 50px;
  max-width: fit-content;
  max-height: fit-content;
  padding: 0.2rem 0.6rem;
  margin: 0.1rem 0.5rem;
  position: relative;
  left: 4px;
}

.custom-check-wrap svg {
  filter: brightness(0) invert(1);
  border-radius: 0.8rem;
  font-size: 10px;
}

.red-icon {
  color: red;
}

.ver-icon-align {
  margin-left: 5px;
}

.verification-icon {
  width: 35px;
  margin: 2px 4px;
  cursor: pointer;
}

.verification-error-text {
  text-decoration: underline;
  cursor: pointer;
  color: #11809c;
}

.click-link {
  color: #0cf;
  font-weight: 700;
  margin-right: 0.2rem;
}

.review-card-block {
  border-radius: 10px;
  background-color: #f9f9f9;
  box-shadow: none;
  padding: 20px 25px;
}
</style>
